import { compact, isArray, uniq } from 'lodash'
import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { connect } from 'react-redux'
import i18n from 'simple-react-i18n'
import ToastrAction from 'toastr/actions/ToastrAction'
import Checkbox from '../../../../components/forms/Checkbox'
import RadioButtons from '../../../../components/forms/RadioButtons'
import Select from '../../../../components/forms/Select'
import NetworkDto from '../../../../referencial/components/network/dto/NetworkDto'
import AppStore from '../../../../store/AppStore'
import { hasBooleanValue } from '../../../../utils/NumberUtil'
import { arrayOf } from '../../../../utils/StoreUtils'
import Job from '../../../dto/DtoJob'
import MultiContributorsAutocomplete from '../../../../referencial/components/contributor/components/MultiContributorsAutocomplete'
import ContributorDto from 'referencial/components/contributor/dto/ContributorDto'
import ContributorAction from 'referencial/components/contributor/actions/ContributorAction'
import { exportFile } from '../../../../utils/ExportDataUtil'
import { nbPerPageLabelTiny } from '../../../../referencial/constants/ReferencialConstants'
import { CardTable } from '../../../../components/datatable/NewTable'
import IntegrationModeDialog from '../IntegrationModeDialog'
import { Button, Grid } from '@mui/material'
import { CITIES, DATA_ADD_LAST_DATA, DATA_ADD_NEW_DATA, DATA_NOTHING, DATA_REPLACE_DATA, DATA_REPLACE_HISTO, DEPARTMENTS, IMPORT_TYPE, STATIONS } from 'traitements/constants/TraitementConstants'
import { darkBlue, mainWhite } from 'utils/constants/ColorTheme'
import { Buffer } from 'buffer'
import NetworkAction from 'referencial/components/network/actions/NetworkAction'

class AdesQualitoWebServicePanel extends Component {
    constructor(props) {
        super(props)
        this.state = {
            measureOptions: [
                {
                    value: DATA_NOTHING,
                    label: i18n.noDataIntegration,
                },
                props.job.jobType === IMPORT_TYPE.ADES_QUALITO ? null : {
                    value: DATA_ADD_LAST_DATA,
                    label: i18n.lastDataIntegration,
                },
                {
                    value: DATA_REPLACE_HISTO,
                    label: i18n.replaceAllHistory,
                },
                {
                    value: DATA_ADD_NEW_DATA,
                    label: i18n.addOnlyNewsDataIntegration,
                },
                this.props.job.jobType === IMPORT_TYPE.ADES_QUALITO ? null : {
                    value: DATA_REPLACE_DATA,
                    label: i18n.replaceDataIntegration,
                },
            ].filter(j => !!j),
        }
    }

    componentDidMount() {
        const filters = this.getFilters()

        this.onChangeFilters({
            selectStationsMode: 'newJob',
            codeMode: filters.codeMode || STATIONS,
            stationCodes: filters.stationCodes || (
                this.props.job.parameters.parameters &&
                this.props.job.parameters.parameters.length
                    ? this.props.job.parameters.parameters
                    : []
            ),
            cityCodes: filters.cityCodes || [],
            departmentCodes: filters.departmentCodes || [],
        })

        AppStore.dispatch(NetworkAction.fetchNetworks())

        if (!this.props.contributors.length) {
            this.props.fetchContributors()
        }
    }

    onDeleteCode = (s) => {
        const filters = this.getFilters()
        if (this.props.isEditMode) {
            if (filters.codeMode === STATIONS) {
                const list = (filters.stationCodes ?? []).filter(p => p !== s.credentials)
                this.onChangeFilters({ stationCodes: list })
            } else if (filters.codeMode === CITIES) {
                const list = (filters.cityCodes ?? []).filter(p => p !== s.credentials)
                this.onChangeFilters({ cityCodes: list })
            } else {
                const list = (filters.departmentCodes ?? []).filter(p => p !== s.credentials)
                this.onChangeFilters({ departmentCodes: list })
            }
        }
    }

    getStations = (filters) => {
        switch (filters.codeMode) {
            case CITIES:
                return (isArray(filters.cityCodes)
                    ? filters.cityCodes
                    : compact([filters.cityCodes])
                ).map(v => ({ credentials: v }))

            case DEPARTMENTS:
                return (isArray(filters.departmentCodes)
                    ? filters.departmentCodes
                    : compact([filters.departmentCodes])
                ).map(v => ({ credentials: v }))

            default:
                return (isArray(filters.stationCodes)
                    ? filters.stationCodes
                    : compact([filters.stationCodes])
                ).map(v => ({ credentials: v }))
        }
    }

    clearAllStations = () => {
        this.onChangeFilters({ stationCodes: [] })
    }

    getDataTypes = type => {
        const { parameters } = this.props.job
        if (parameters.dataTypes && parameters.dataTypes.length) {
            return parameters.dataTypes.find(d => d.includes(type)) || ''
        }
        return ''
    }

    handleChangeDataIntegration = integration => {
        const { parameters } = this.props.job
        const dataTypes = parameters.dataTypes.filter(d => !d.includes('DATA'))
        if (integration) {
            dataTypes.push(integration)
        }
        this.props.onChangeDataTypes(dataTypes)
    }

    handleChangeStationIntegration = integration => {
        const { parameters } = this.props.job
        const dataTypes = parameters.dataTypes.filter(d => !d.includes('station'))
        if (integration) {
            dataTypes.push('stationIntegration')
        }
        this.props.onChangeDataTypes(dataTypes)
    }

    onChangeFilters = (changes) => {
        const parameters = {
            ...this.props.job.parameters,
            filters: [JSON.stringify({
                ...this.getFilters(),
                ...changes,
            })],
        }
        this.props.onChangeJob({ parameters })
    }

    getFilters = () => {
        const newFilters = this.props.job.parameters.filters.length ? JSON.parse(this.props.job.parameters.filters[0]) : {}
        return { measureCote: 2, descriptionImportMode: i18n.waterPointAndHisto, addCodesToADESNetwork: true, ...newFilters }
    }

    addCode = () => {
        const filters = this.getFilters()
        const code = this.refs.txtAddBssCode.value
        if (this.props.isEditMode) {
            if (filters.codeMode === DEPARTMENTS) {
                this.onChangeFilters({ departmentCodes: [code, ...(filters.departmentCodes ?? [])] })
                this.refs.txtAddBssCode.value = ''
            } else if (filters.codeMode === CITIES) {
                this.onChangeFilters({ cityCodes: [code, ...(filters.cityCodes ?? [])] })
                this.refs.txtAddBssCode.value = ''
            } else {
                this.onChangeFilters({ stationCodes: [code, ...(filters.stationCodes ?? [])] })
                this.refs.txtAddBssCode.value = ''
            }
        }
    }

    onImportFile = e => {
        if (this.props.isEditMode) {
            const reader = new FileReader()
            const file = e.target.files[0]
            reader.onload = upload => {
                const split = upload.target.result.split(',')
                if (split[0].indexOf('text/csv') > 0 || split[0].indexOf('vnd.ms-excel') > 0) {
                    const buf = Buffer.from(split[1], 'base64').toString()
                    const codes = buf.replace(/;/g, '').split('\n').map(b => b.trim())
                    const filteredCodes = codes.filter((c) => c !== '')
                    const filters = this.getFilters()
                    if (filters.codeMode === 'departments') {
                        this.onChangeFilters({ departmentCodes: uniq([ ...(filters.departmentCodes ?? []), ...filteredCodes ]) })
                    } else if (filters.codeMode === 'cities') {
                        this.onChangeFilters({ cityCodes: uniq([ ...(filters.cityCodes ?? []), ...filteredCodes ]) })
                    } else {
                        this.onChangeFilters({ stationCodes: uniq([ ...(filters.stationCodes ?? []), ...filteredCodes ]) })
                    }
                } else {
                    AppStore.dispatch(ToastrAction.error(i18n.theSelectedFileMustBeInCsvFormat))
                }
                e.target.value = ''
            }
            reader.readAsDataURL(file)
        }
    }

    getFiltersPanel = (filters) => {
        return (
            <Grid size={5}>
                <Select
                    options={ this.props.networks }
                    keyLabel='mnemonic'
                    label={ i18n.network }
                    nullLabel='&nbsp;'
                    onChange={ value => this.onChangeFilters({ network: value }) }
                    value={ filters.network }
                    disabled
                    keyValue='id'
                />
            </Grid>
        )
    }

    render() {
        const disabled = !this.props.isEditMode

        const descriptionImportModes = [
            { code: 'all', name: i18n.waterPointAndHisto },
            { code: 'PointEau', name: i18n.pointeauOnly },
        ]

        const codesTypes = [
            { code: STATIONS, name: i18n.stations },
            { code: CITIES, name: i18n.cities },
            { code: DEPARTMENTS, name: i18n.departments },
        ]

        const filters = this.getFilters()
        const myData = this.getStations(filters)


        return (
            <>
                <Grid container spacing={2}>
                    <Grid size={3}>
                        <Checkbox
                            checked={ !!this.getDataTypes('station') }
                            label={ i18n.integrateStationInfo }
                            onChange={ this.handleChangeStationIntegration }
                            disabled={ disabled }
                        />
                    </Grid>
                    <Grid size={2}>
                        <Checkbox
                            checked={ hasBooleanValue(filters.syncEvents) ? filters.syncEvents : true }
                            label={ i18n.syncEvents }
                            onChange={ v => this.onChangeFilters({ syncEvents: v }) }
                            disabled={ disabled }
                        />
                    </Grid>
                    <Grid size={2}>
                        <Checkbox
                            checked={ hasBooleanValue(filters.syncNetworks) ? filters.syncNetworks : true }
                            label={ i18n.syncNetworks }
                            onChange={ v => this.onChangeFilters({ syncNetworks: v }) }
                            disabled={ disabled }
                        />
                    </Grid>
                    <Grid size={4}>
                        <Select
                            options={ this.state.measureOptions }
                            label={ i18n.dataIntegration }
                            value={ this.getDataTypes('DATA') }
                            labelSpan={ <IntegrationModeDialog /> }
                            onChange={ this.handleChangeDataIntegration }
                            disabled={ disabled }
                        />
                    </Grid>
                    <Grid size={1} />
                </Grid>
                <Grid container spacing={2}>

                    <Grid size={4}>
                        <Checkbox
                            checked={ filters.dontCheckInternalReferences }
                            label={ i18n.dontCheckInternalReferences }
                            onChange={ v => this.onChangeFilters({ dontCheckInternalReferences: v }) }
                            disabled={ disabled }
                        />
                    </Grid>
                    <Grid size={3}>
                        <Checkbox
                            checked={ filters.doNotImportClosedStations }
                            label={ i18n.doNotImportClosedStations }
                            onChange={ v => this.onChangeFilters({ doNotImportClosedStations: v }) }
                            disabled={ disabled }
                        />
                    </Grid>
                    <Grid size={5}>
                        <MultiContributorsAutocomplete
                            multiple
                            options={this.props.contributors}
                            values={filters.excludedProducers}
                            label={ i18n.producersExcluded }
                            onChange={values => {
                                this.onChangeFilters({ excludedProducers: values })
                            }}
                            disabled={ disabled }
                        />
                    </Grid>

                </Grid>
                <Grid container spacing={2}>
                    <Grid size={4}>
                        <Select
                            label={ i18n.importMode }
                            options={ descriptionImportModes }
                            value={ filters.descriptionImportMode }
                            onChange={ v => this.onChangeFilters({ descriptionImportMode: v }) }
                            disabled={ disabled }
                        />
                    </Grid>
                    <Grid size={3}>
                        <Checkbox
                            checked={ filters.addCodesToADESNetwork }
                            label={ i18n.addCodesToADESNetwork }
                            onChange={ v => this.onChangeFilters({ addCodesToADESNetwork: v }) }
                            disabled={ disabled }
                        />
                    </Grid>
                    <Grid size={5}>
                        <Select
                            options={ this.props.networks }
                            keyLabel='mnemonic'
                            label={ i18n.synchNetwork }
                            nullLabel='&nbsp;'
                            onChange={ value => this.onChangeFilters({ selectedNetwork: value }) }
                            value={ filters.selectedNetwork }
                            disabled={ disabled }
                            keyValue='id'
                        />
                    </Grid>

                </Grid>
                <Grid container mt={2} mb={2} justifyContent='space-between' spacing={2}>
                    <Grid size={3}>
                        <label>{ i18n.importFile }</label>
                    </Grid>
                    <Grid size={6}>
                        <Button
                            variant='contained'
                            component='label'
                            disabled={ disabled }
                            sx={{ padding: '5px', fontSize: '14px' }}
                        >
                            {i18n.importLabelStation}
                            <input
                                type='file'
                                accept='.csv'
                                hidden
                                onChange={this.onImportFile}
                            />
                        </Button>
                    </Grid>
                    <Grid size={3} />
                </Grid>
                <Grid container justifyContent='space-between' spacing={2}>
                    <Grid size={3}>
                        <label>{ i18n.addCredential }</label>
                    </Grid>
                    <Grid size={5}>
                        <input
                            id='txtAddBssCode' type='text'
                            placeholder={ i18n.BSSExample }
                            ref='txtAddBssCode'
                            disabled={ disabled }
                        />
                        <label className='tinyLabel'>{ i18n.theCodeMustBePresentInTheRepositoryAndDefinedByTheCode }</label>
                    </Grid>
                    <Grid size={4}>
                        <Grid container>
                            <Grid size={3} offset={1}>
                                <a
                                    className='waves-effect waves-light btn'
                                    onClick={ this.addCode }
                                    disabled={ disabled }
                                >
                                    { i18n.add }
                                </a>
                            </Grid>
                        </Grid>
                    </Grid>
                    <Grid size={5}>
                        { filters.codeMode === CITIES || filters.codeMode === DEPARTMENTS ? this.getFiltersPanel(filters) : undefined}
                    </Grid>
                </Grid>
                <Grid container spacing={2} alignItems='center' sx={{ padding: '10' }}>
                    <Grid size={3}>
                        <RadioButtons
                            elements={codesTypes}
                            selected={filters.codeMode}
                            onChange={v => this.onChangeFilters({ codeMode: v })}
                            title={i18n.schemeAgencyID} {...disabled}
                            disabled={ disabled }
                        />
                    </Grid>
                    <Grid size={12}>
                        <CardTable
                            headers={ ['credentials'] }
                            rows={ myData }
                            title={ filters.codeMode === STATIONS ? i18n.credentials : i18n[filters.codeMode] }
                            rowsPerPageOptions={ nbPerPageLabelTiny }
                            lineActions={[
                                { icon: 'delete', onClick: this.onDeleteCode, displayed: this.props.isEditMode },
                            ]}
                            actions={[{
                                icon: 'download',
                                onClick: () => exportFile({
                                    data: [{ ...(myData[0]), headers: ['credentials'] }, ...(myData.slice(1, myData.length))],
                                    titleFile: i18n.credentials,
                                }),
                                color: mainWhite,
                                tooltip: i18n.download,
                            }]}
                            exportButtonOnHeader
                            color={darkBlue}
                        />
                    </Grid>
                </Grid>
            </>
        )
    }
}

AdesQualitoWebServicePanel.propTypes = {
    job: PropTypes.instanceOf(Job).isRequired,
    addCode: PropTypes.func.isRequired,
    addBssCode: PropTypes.func.isRequired,
    isEditMode: PropTypes.bool,
    onChangeDataTypes: PropTypes.func,
    onChangeFilters: PropTypes.func,
    onChangeJob: PropTypes.func,
    networks: arrayOf(NetworkDto),
    contributors: PropTypes.arrayOf(PropTypes.instanceOf(ContributorDto)),
    fetchContributors: PropTypes.func,
}

const mapStateToProps = store => ({
    networks: store.NetworkReducer.networks,
    contributors: store.ContributorReducer.contributors,
})

const mapDispatchToProps = {
    fetchContributors: ContributorAction.fetchContributors,
}

export default connect(mapStateToProps, mapDispatchToProps)(AdesQualitoWebServicePanel)
